import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import getFonts from './getFonts';
import loadArtemisFonts from './v2/components/ui/loadArtemisFonts';
import {focusHighlight} from './v2/form/Form.styles';
import isUsingArtemisStyles from './v2/selectors/isUsingArtemisStyles';
import setContrastColorBasedOnBackground from './v2/style-helper/setContrastColorBasedOnBackground';

const overrideArtemisStyles = props => ({
  fontSize: props.fontSize,
});

const useStyles = createUseStyles({
  baseStyles: props => ({
    fontFamily: props.theme.base.fontFamily,
    fontSize: props.theme.base.fontSize,
    fontStretch: props.theme.base.fontStretch,
    backgroundColor: props.theme.bodyBackgroundColour,
    textTransform: props.theme.core.typography.textTransform,
    
    ...(props.isUsingArtemisStyles && props.theme.typography?.bodyText)
    && loadArtemisFonts(props.theme.typography.bodyText),
    
    ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.base.overrideArtemisFontSize])
    && overrideArtemisStyles(props.theme.typography[props.theme.base.overrideArtemisFontSize]),
    
    '& select, input, textarea': {
      backgroundColor: props.theme.inputBackgroundColour,
    },
    
    '& a': {
      color: props.theme.base.color,
      textDecoration: 'underline',
      cursor: 'pointer',
      
      '&:visited': {
        color: props.theme.base.color,
        textDecoration: 'underline',
      },
      '&:hover': {
        color: props.theme.base.color,
        textDecoration: 'none',
      },
      '&:active': {
        color: props.theme.base.color,
        textDecoration: 'underline',
      },
      '&:focus': {
        ...focusHighlight((props.isUsingArtemisStyles && props.theme.button.low?.regular?.focus?.borderColor)
          ? props.theme.button.low.regular.focus.borderColor : props.theme.focusHighlightColour, 2),
      },
      '&[data-test="PageHeader__logoLink"]:focus': {
        ...(props.theme.focusHighlightColour === props.theme.header.backgroundColour)
        && focusHighlight(setContrastColorBasedOnBackground(props.theme.header.backgroundColour), 2),
      },
    },
  }),
});

function loadFonts(fontData) {
  const style = document.createElement('style');
  style.type = 'text/css';
  
  Object.values(fontData).forEach((fontEntry) => {
    if (fontEntry.kind === 'webfonts#webfont') {
      getFonts(fontEntry.fontUrls);
    }
    
    const {family} = fontEntry;
    
    fontEntry.fontUrls.forEach((fontUrl) => {
      if (fontUrl.url) {
        const fontFaceRule = `
          @font-face {
            font-family: '${family}';
            src: url('${fontUrl.url}') format('woff');
            font-weight: ${fontUrl.weight};
            font-style: ${fontUrl.style};
          }
        `;
        style.innerHTML += fontFaceRule;
      }
    });
  });
  
  document.head.appendChild(style);
}

export function BaseStyleWrapper(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  if (props.isUsingArtemisStyles && theme.typography) {
    loadFonts(theme.typography.urls);
  }
  
  return (
    <div className={classes.baseStyles}>
      {props.children}
    </div>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

BaseStyleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(BaseStyleWrapper);
